import { backend } from "./utils";
import type { ModalityOption } from "@/stores/globalFilterStore";

interface ModalityApiResponse {
    slug: string;
    title: string;
    description: string;
    icon: string;
    taxonomy_slugs: string[];
}

function mapModalities(data: ModalityApiResponse[]): ModalityOption[] {
    return data.map((m) => ({
        value: m.slug,
        title: m.title,
        description: m.description,
        icon: m.icon,
        taxonomySlugs: m.taxonomy_slugs ?? [],
    }));
}

export async function fetchModalities(): Promise<ModalityOption[]> {
    const response = await backend.get("/api/modalities");
    return mapModalities(await response.json());
}

export async function fetchAvailableModalities(): Promise<ModalityOption[]> {
    const response = await backend.get("/api/modalities/available");
    return mapModalities(await response.json());
}

export async function updateModality(value: string): Promise<void> {
    await backend.patch("/api/user/modality", { active_modality: value });
}
